import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import led from "../images/bulb.webp";

const config = {
  API_BASE_URL: "https://qhlightingpakistan.com/backend/public"
};

const categories = [
  { name: "Consumer", id: "consumer", api: "/api/getconsumer" },
  { name: "Professional", id: "professional", api: "/api/getprofessional" },
  { name: "PCB", id: "pcb", api: "/api/getpcb" }, // ✅ Added API for PCB
  // { name: "Smart Lighting", id: "smart", api: "/api/getsmart" },

];

const CategorySection = () => {
  const [selectedCategory, setSelectedCategory] = useState("consumer");
  const [seriesData, setSeriesData] = useState({
    consumer: [],
    professional: [],
    smart: [],
    pcb: [],
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategoryData = async (categoryId, apiUrl) => {
      if (!apiUrl) return; // ✅ Avoid fetching if no API URL

      try {
        const response = await axios.get(`${config.API_BASE_URL}${apiUrl}`);
        console.log(`API Response for ${categoryId}:`, response.data);

        if (!Array.isArray(response.data)) {
          throw new Error("Invalid API response");
        }

        setSeriesData((prev) => ({
          ...prev,
          [categoryId]: response.data,
        }));
      } catch (error) {
        console.error(`Error fetching ${categoryId} data:`, error);
      }
    };

    categories.forEach((category) => fetchCategoryData(category.id, category.api));
  }, []);

  const settings = {
    dots: false,
    infinite: seriesData[selectedCategory].length > 1,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <FaArrowRight className="slick-arrow next" />,
    prevArrow: <FaArrowLeft className="slick-arrow prev" />,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: true, centerPadding: "40px" } },
    ],
  };

  return (
    <Container className="category-section">
      <Row>
        <Col md={12} className="category-boxes mb-5">
          {categories.map((category) => (
            <Card
              key={category.id}
              className={`category-card ${selectedCategory === category.id ? "active" : ""}`}
              onClick={() => {
                setSelectedCategory(category.id);
                if (category.id === "pcb") {
                  navigate("/Ourproduct"); // ✅ Navigate to PCB page
                }
              }}
            >
              <Card.Body>{category.name}</Card.Body>
            </Card>
          ))}
        </Col>

        <Col md={12}>
          <Slider {...settings}>
            {seriesData[selectedCategory].map((item, index) => (
              <div key={index} className="slider-item">
                <Card
                  className="series-card"
                  onClick={() => navigate(`/ProductList/${item.id}`)}
                >
                  <div className="image-container">
                    <Card.Img variant="top" src={item.image_url || led} alt={item.category_name} />
                  </div>
                  <Card.Body>
                    <Card.Title className="title">{item.category_name}</Card.Title>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Slider>
        </Col>
      </Row>
    </Container>
  );
};

export default CategorySection;
